import api from "../index";
import { qs } from "../../utils/utils.js";

export const GetWalletApi = (userId, params) => api.get(`wallet/get-walletdetailsbyrule/${userId}?${qs(params)}`);
export const WalletToAccountTransferApi = (data) => api.post('trading/trading-account-deposit', data);
export const AccountToWalletTransferApi = (data) => api.post('trading/internal-withdrawal-request', data);
export const InternalTransferApi = (data) => api.post('trading/internal-transfer', data);
export const GetAccountsApi = (params) => api.get(`usermaster/vertex-account-trader?${qs(params)}`);
export const GetAllInternalTransferApi = (params) => api.get(`wallet/internal-transfer-history?${qs(params)}`);